export enum OrganizationOrdersTabValues {
    Orders = 'orders',
    Requests = 'requests',
}
